// @flow
import React from 'react';

type Props = {
  children: Object | Object[],
  className: string
}

const Dropdown = (props: Props) => {
  const { children, className } = props;

  return (
    <div className={className}>{children}</div>
  );
};

export default Dropdown;
